// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ---------------------------------------------------------------------------
 * Shared empty-state. Clean neutral look (grey badge) with a quiet staggered
 * entrance. Brand-agnostic: accents derive from --ion-color-* / --ui-*.
 * Keyframes are prefixed (nc-*) to avoid global collisions.
 * ------------------------------------------------------------------------- */
@keyframes nc-pop-in {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes nc-fade-up {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
:host {
  display: flex;
  flex-direction: column;
  transform: translateY(-5%);
}

.nc-empty {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 48vh;
  padding: 40px 24px;
  text-align: center;
  animation: nc-pop-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.nc-illustration {
  position: relative;
  width: 140px;
  height: 140px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nc-badge {
  position: relative;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ui-surface-2);
  border: 1px solid var(--ui-border);
  box-shadow: var(--ui-shadow-1), 0 0 0 10px rgba(15, 23, 42, 0.035);
}
.nc-badge ion-icon {
  font-size: 44px;
  color: var(--ui-text-muted);
}

.nc-title {
  margin: 0 0 8px;
  font-family: var(--ion-font-family, "Helvetica Neue", Arial, sans-serif);
  font-size: 20px;
  font-weight: 700;
  color: var(--ion-text-color, #1f2937);
  animation: nc-fade-up 420ms ease-out 110ms both;
}

.nc-hint {
  margin: 0 0 24px;
  max-width: 340px;
  font-family: var(--ion-font-family, "Helvetica Neue", Arial, sans-serif);
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--ui-text-muted);
  animation: nc-fade-up 420ms ease-out 180ms both;
}

.nc-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: var(--ui-radius-custom);
  cursor: pointer;
  font-family: var(--ion-font-family, "Helvetica Neue", Arial, sans-serif);
  font-size: 15px;
  font-weight: 600;
  color: var(--ion-color-primary-contrast, #fff);
  background: var(--ion-color-primary);
  animation: nc-fade-up 420ms ease-out 250ms both;
}
.nc-cta ion-icon {
  font-size: 20px;
}

/* Compact variant — for embedded / in-card lists, where the full-height hero
 * would be oversized. Smaller badge/typography and no tall min-height. */
.nc-compact {
  min-height: 0;
  padding: 32px 16px;
}
.nc-compact .nc-illustration {
  width: 112px;
  height: 112px;
  margin-bottom: 18px;
}
.nc-compact .nc-badge {
  width: 84px;
  height: 84px;
  box-shadow: var(--ui-shadow-1), 0 0 0 8px rgba(15, 23, 42, 0.035);
}
.nc-compact .nc-badge ion-icon {
  font-size: 40px;
}
.nc-compact .nc-title {
  font-size: 17px;
}
.nc-compact .nc-hint {
  font-size: 13px;
  margin-bottom: 16px;
}

/* Framed variant: a dashed box, with no vertical shift */
:host(.no-content--framed) {
  transform: none;
}

:host(.no-content--framed) .nc-empty {
  border: 1.5px dashed rgba(15, 23, 42, 0.16);
  border-radius: var(--ui-radius-custom);
  background: var(--ui-surface);
}

@media (prefers-reduced-motion: reduce) {
  .nc-empty,
  .nc-title,
  .nc-hint,
  .nc-cta {
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/no-content/no-content.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;8EAAA;AAOA;EACE;IACE,UAAA;IACA,sCAAA;EAAF;EAGA;IACE,UAAA;IACA,iCAAA;EADF;AACF;AAKA;EACE;IACE,UAAA;IACA,2BAAA;EAHF;EAMA;IACE,UAAA;IACA,wBAAA;EAJF;AACF;AAOA;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;AALF;;AAQA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8DAAA;AALF;;AAQA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kCAAA;EACA,kEAAA;AALF;AAOE;EACE,eAAA;EACA,2BAAA;AALJ;;AASA;EACE,eAAA;EACA,wEAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,+CAAA;AANF;;AASA;EACE,gBAAA;EACA,gBAAA;EACA,wEAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,+CAAA;AANF;;AASA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,eAAA;EAEA,wEAAA;EACA,eAAA;EACA,gBAAA;EACA,8CAAA;EACA,oCAAA;EACA,+CAAA;AAPF;AASE;EACE,eAAA;AAPJ;;AAWA;yEAAA;AAEA;EACE,aAAA;EACA,kBAAA;AARF;AAUE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,iEAAA;AATJ;AAWI;EACE,eAAA;AATN;AAaE;EACE,eAAA;AAXJ;AAcE;EACE,eAAA;EACA,mBAAA;AAZJ;;AAgBA,yDAAA;AACA;EACE,eAAA;AAbF;;AAgBA;EACE,2CAAA;EACA,sCAAA;EACA,6BAAA;AAbF;;AAgBA;EAEE;;;;IAIE,0BAAA;EAdF;AACF","sourcesContent":["/* ---------------------------------------------------------------------------\n * Shared empty-state. Clean neutral look (grey badge) with a quiet staggered\n * entrance. Brand-agnostic: accents derive from --ion-color-* / --ui-*.\n * Keyframes are prefixed (nc-*) to avoid global collisions.\n * ------------------------------------------------------------------------- */\n\n// Container entrance: a subtle scale + lift.\n@keyframes nc-pop-in {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n// Per-element entrance used to stagger title / hint / CTA.\n@keyframes nc-fade-up {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n:host {\n  display: flex;\n  flex-direction: column;\n  transform: translateY(-5%);\n}\n\n.nc-empty {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 48vh;\n  padding: 40px 24px;\n  text-align: center;\n  animation: nc-pop-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.nc-illustration {\n  position: relative;\n  width: 140px;\n  height: 140px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nc-badge {\n  position: relative;\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--ui-surface-2);\n  border: 1px solid var(--ui-border);\n  box-shadow: var(--ui-shadow-1), 0 0 0 10px rgba(15, 23, 42, 0.035);\n\n  ion-icon {\n    font-size: 44px;\n    color: var(--ui-text-muted);\n  }\n}\n\n.nc-title {\n  margin: 0 0 8px;\n  font-family: var(--ion-font-family, \"Helvetica Neue\", Arial, sans-serif);\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--ion-text-color, #1f2937);\n  animation: nc-fade-up 420ms ease-out 110ms both;\n}\n\n.nc-hint {\n  margin: 0 0 24px;\n  max-width: 340px;\n  font-family: var(--ion-font-family, \"Helvetica Neue\", Arial, sans-serif);\n  font-size: 14.5px;\n  line-height: 1.6;\n  color: var(--ui-text-muted);\n  animation: nc-fade-up 420ms ease-out 180ms both;\n}\n\n.nc-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: var(--ui-radius-custom);\n  cursor: pointer;\n  // native <button> does NOT inherit font-family by default — force the app font\n  font-family: var(--ion-font-family, \"Helvetica Neue\", Arial, sans-serif);\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ion-color-primary-contrast, #fff);\n  background: var(--ion-color-primary);\n  animation: nc-fade-up 420ms ease-out 250ms both;\n\n  ion-icon {\n    font-size: 20px;\n  }\n}\n\n/* Compact variant — for embedded / in-card lists, where the full-height hero\n * would be oversized. Smaller badge/typography and no tall min-height. */\n.nc-compact {\n  min-height: 0;\n  padding: 32px 16px;\n\n  .nc-illustration {\n    width: 112px;\n    height: 112px;\n    margin-bottom: 18px;\n  }\n\n  .nc-badge {\n    width: 84px;\n    height: 84px;\n    box-shadow: var(--ui-shadow-1), 0 0 0 8px rgba(15, 23, 42, 0.035);\n\n    ion-icon {\n      font-size: 40px;\n    }\n  }\n\n  .nc-title {\n    font-size: 17px;\n  }\n\n  .nc-hint {\n    font-size: 13px;\n    margin-bottom: 16px;\n  }\n}\n\n/* Framed variant: a dashed box, with no vertical shift */\n:host(.no-content--framed) {\n  transform: none;\n}\n\n:host(.no-content--framed) .nc-empty {\n  border: 1.5px dashed rgba(15, 23, 42, 0.16);\n  border-radius: var(--ui-radius-custom);\n  background: var(--ui-surface);\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .nc-empty,\n  .nc-title,\n  .nc-hint,\n  .nc-cta {\n    animation: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
